import React, { Fragment, useEffect, useState } from "react";
import {
  Alert,
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Popover,
  PopoverBody,
  PopoverHeader,
  Row,
} from "reactstrap";

import { Link, useHistory } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import DatePicker from "react-datepicker";
import moment from "moment/moment";
import {
  CarouseNavigation,
  formatDateTimeForDisplayUS,
} from "../../../../../utils/common";
import { BillingDetails, NotFoundData } from "../../../../../constant";
import BillingOrderDetail from "../orderDetail";
import withReducer from "../../../../../store/withReducer";
import salesOrderInvoiceReducer from "../../../store";
import {
  getCountryList,
  getCountryListData,
  getDraftOrder,
} from "../../../store/draftOrderSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  addSalesOrderInvoice,
  editSaleOrderInvoice,
  getCreateInvoiceData,
  getInvoiceByOrder,
  getPendingSaleOrderInvoiceItems,
  setInvoiceFromSettings,
  setOrderInvoices,
  updateSalesOrderInvoice,
  deleteSalesOrderInvoice,
  downloadSalesOrderXeroInvoicePdf,
  downloadInvoiceRMAPdf,
} from "../../../store/saleOrderInvoiceSlice";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import SaleOrderProductInvoiceJqx from "./content/saleOrderProductInvoicejqx";
import SearchProductModal from "../../../draft-order/form/content/searchProductModal";
import OrderDiscount from "../../../draft-order/form/content/orderDiscount";
import OrderShipment from "../../../draft-order/form/content/orderShipment";
import OrderTax from "../../../draft-order/form/content/orderTax";
import SalesOrderDuty from "../../create/content/salesOrderDuty";
import SaleOrderPayment from "../../create/content/saleOrderPayment";
import {
  addSalesOrders,
  setOrderData,
  downloadSalesOrderInvoicePdf,
  sendSalesOrderInvoiceToQuickBook,
} from "../../../store/salesOrderSlice";
import LogActivity from "../../../../log";
import {
  getCreateData,
  setFromSettings,
} from "../../../store/saleOrderFulfillmentSlice";
import Select from "react-select";
import SalesOrderInvoiceView from "./view";
import ButtonLoader from "../../../../../share-components/ui/buttonLoader";
import AsyncSelect from "react-select/async";
import {
  mapSearchCustomerAutoSuggestion,
  mapSearchPaymentMethodAutoSuggestion,
} from "../../../../../utils/mapper";
import { customerAutoSuggestionApi } from "../../../../../services/order";
import { invoiceAutoSuggestionApi } from "../../../../../services/manage-order/saleOrderInvoiceService";
import SweetAlert from "sweetalert2";
import { addReturnItems } from "../../../store/orderSlice";
import { getPaymentAutoSuggestionApi } from "../../../../../services/manage-order/setting/paymentMethodService";
import PickUpDetail from "./content/pickUpDetail";
import OrderInvoiceItemDiscount from "../../../draft-order/form/content/invoiceItemDiscount";

const settings = {
  dots: false,
  infinite: false,
  slidesToShow: 5,
  slidesToScroll: 1,
  nextArrow: <CarouseNavigation icon="fa-arrow-right" />,
  prevArrow: <CarouseNavigation icon="fa-arrow-left" />,
};
const defaultValues = {
  id: "",
  ordered_products: [],
  due_date: "",
  tags: [],
  duty: "",
  terms: "",
  discount: "",
  shipping: "",
  tax: "",
  xero_id: "",
  total_net_weight: "",
  total_gross_weight: "",
  total_no_of_boxes: "",
  bank: "",
  is_weight_added: "",
  trade_option: "",
  net_unit_type: 1,
  gross_unit_type: 1,
  merge_invoices: [],
  is_merge: false,
  is_tax: false,
  return_request_items: [],
  payment_method: "",
  weaver_qb_status: null,
  dj_qb_status: null,
  po_created: null,
  can_delete: false,
  delete_block_reason: "",
  is_deleted: false,
  deleted_at: "",
  deleted_by: "",
};
const schema = yup.object().shape({
  total_gross_weight: yup
    .string()
    .required("You must enter total gross weight"),
  total_net_weight: yup.string().required("You must enter total net weight"),
  total_no_of_boxes: yup.string().required("You must enter total no of boxes"),
  terms: yup
    .object()
    .shape({ value: yup.string() })
    .nullable()
    .required("You must select a term."),
});
const BillIngInvoice = (props) => {
  const { id, order_id } = props;
  let history = useHistory();
  const dispatch = useDispatch();
  const draftOrderState = useSelector(({ order }) => order.draftOrder);
  const salesOrderInvoiceState = useSelector(
    ({ order }) => order.salesOrderInvoice
  );
  const salesOrderState = useSelector(({ order }) => order.salesOrder);
  const [isEditable, setIsEditable] = useState(!id);
  const [buttonDisable, setButtonDisable] = useState(false);
  const [qbButtonDisable, setQbButtonDisable] = useState(false);
  const [qbCompanyModal, setQbCompanyModal] = useState(false);
  const [selectedQbCompany, setSelectedQbCompany] = useState("weaver");
  const authData = useSelector(({ authReducer }) => authReducer);
  const userState = useSelector(({ authReducer }) => authReducer.data);
  const [dropdownStatusOpen, setDropdownStatusOpen] = useState(false);
  const [dropdownRMAOpen, setDropdownRMAOpen] = useState(false);
  const [isProductValueChange, setIsProductValueChange] = useState(true);
  const [showBankDropdown, setShowBankDropdown] = useState(false);
  const [isDiscountValueChange, setIsDiscountValueChange] = useState(true);

  const toggleStatusDropdown = () => {
    setDropdownStatusOpen(!dropdownStatusOpen);
  };

  const toggleRMADropdown = () => {
    setDropdownRMAOpen(!dropdownRMAOpen);
  };

  const {
    handleSubmit,
    formState,
    reset,
    control,
    register,
    setValue,
    trigger,
    getValues,
    watch,
  } = useForm({
    mode: "onChange",
    defaultValues,
    resolver: yupResolver(schema),
  });
  const { errors, isDirty } = formState;
  const weaverQbStatus = watch("weaver_qb_status");
  const djQbStatus = watch("dj_qb_status");
  const canDelete = watch("can_delete");
  const deleteBlockReason = watch("delete_block_reason");
  const isDeleted = watch("is_deleted");
  useEffect(() => {
    if (isDeleted) {
      setIsEditable(false);
    }
  }, [isDeleted]);
  useEffect(() => {
    if (order_id) {
      const data = {
        id: order_id,
        params: {
          is_check_xero: 0,
        },
      };
      dispatch(getInvoiceByOrder(data)).then((res) => {
        dispatch(setOrderInvoices(res.payload));
      });
    }

    if (order_id && id) {
      dispatch(editSaleOrderInvoice(id)).then((res) => {
        if (!res.error) {
          dispatch(setOrderData(res.payload.order));
          reset(res.payload.invoice);
          setIsProductValueChange(!isProductValueChange);
          setIsDiscountValueChange(!isDiscountValueChange);
        }
      });
    } else {
      if (order_id) {
        dispatch(getPendingSaleOrderInvoiceItems(order_id)).then((res) => {
          if (!res.error) {
            dispatch(setOrderData(res.payload.order));
            const selectedTerms = res.payload.order?.terms;
            if (selectedTerms) {
              const dueDate = moment()
              .add(selectedTerms.no_of_days, "days")
              .format("YYYY-MM-DD");
              setValue("terms", selectedTerms);
              setValue("due_date", dueDate);
              trigger("due_date");
            }
            setValue("ordered_products", res.payload.order_products);
            trigger("ordered_products");
            setIsProductValueChange(!isProductValueChange);
            setIsDiscountValueChange(!isDiscountValueChange);
          }
        });
      }
    }
  }, [id, order_id]);
  useEffect(() => {
    dispatch(getCreateInvoiceData()).then((res) => {
      dispatch(setInvoiceFromSettings(res.payload));
    });
    dispatch(getCountryList()).then((res) => {
      dispatch(getCountryListData(res.payload));
    });
  }, [dispatch]);

  const typePromiseOption = (inputValue) =>
    new Promise((resolve) => {
      const data = {
        value: inputValue,
        invoice_id: id,
        unit_type: getValues("net_unit_type"),
      };
      setTimeout(() => {
        resolve(
          mapSearchCustomerAutoSuggestion(invoiceAutoSuggestionApi(data))
        );
      });
    });

  const onSubmit = (data) => {
    setButtonDisable(true);
    const invoiceData = {
      sales_order_id: order_id,
      ...data,
      terms: data.terms.id,
      bank: data.bank?.id,
      payment_method: data.payment_method?.value,
      trade_option: data.trade_option?.id,
      merge_invoices: data.merge_invoices.map((num) => num.value),
      po_created: data.po_created ? moment(data.po_created).format("YYYY-MM-DD") : null,
      ordered_products: data.ordered_products
        .filter(function (v, i) {
          return v.is_selected;
        })
        .map(function (item, index) {
          return {
            id: item.id,
            sales_order_line_item_id: item.sales_order_line_item_id,
            quantity: item.quantity,
            price: item.rate,
            sub_total: item.total_price,
            tax_amount: item.tax_amount,
            total_amount: item.gross_price,
            item_discount: item.item_discount ?? [],
          };
        }),
    };

    if (id) {
      invoiceData.id = id;
      dispatch(updateSalesOrderInvoice({ ...invoiceData })).then((res) => {
        setIsEditable(!isEditable);
        setValue("is_weight_added", true);

        setButtonDisable(false);
      });
    } else {
      dispatch(addSalesOrderInvoice({ ...invoiceData })).then((res) => {
        if (!res.error) {
          setButtonDisable(false);
          history.push(
            `/order/sale/${order_id}/billing/invoice/${res.payload.id}`
          );
        }
      });
    }
  };

  const sendToQuickBooks = () => {
    setSelectedQbCompany("weaver");
    setQbCompanyModal(true);
  };

  const confirmQbSync = () => {
    setQbCompanyModal(false);
    const companyLabel = selectedQbCompany === "weaver" ? "Weaver QuickBooks" : "D&J QuickBooks";
    SweetAlert.fire({
      title: `Are you sure want to send this invoice to ${companyLabel}?`,
      text: "Once confirmed, no changes will be accepted in this invoice",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Proceed",
      cancelButtonText: "No, cancel",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        setQbButtonDisable(true);
        dispatch(sendSalesOrderInvoiceToQuickBook({ invoice_id: id, company: selectedQbCompany })).then(
          (res) => {
            setQbButtonDisable(false);
            if (!res.error) {
              if (selectedQbCompany === "weaver") {
                setValue("weaver_qb_status", res.payload.weaver_qb_status);
              } else {
                setValue("dj_qb_status", res.payload.dj_qb_status);
              }
              setValue("can_delete", res.payload.can_delete);
              setValue("delete_block_reason", res.payload.delete_block_reason);
            }
          }
        );
      }
    });
  };

  const onDeleteInvoice = () => {
    SweetAlert.fire({
      title: "Are you sure you want to delete this invoice?",
      text: "This action cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Delete",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(deleteSalesOrderInvoice(id)).then((res) => {
          if (!res.error) {
            history.push(`/order/sale/${order_id}/billing/invoice`);
          }
        });
      }
    });
  };

  const processPDFDownload = (name, isCommercial) => {
    const data = {
      id: id,
      params: {
        is_commercial: isCommercial,
      },
    };
    dispatch(downloadSalesOrderInvoicePdf(data)).then((res) => {
      const url = window.URL.createObjectURL(new Blob([res.payload]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `${getValues("invoice_no")}_${name.replace(/\s+/g, "-")}_${new Date().toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' }).replace(/\//g, '-')}.pdf`
      ); //or any other extension
      document.body.appendChild(link);
      link.click();
    });
  };

  const processRMAPDFDownload = (name, id) => {
    const data = {
      id: id,
    };
    dispatch(downloadInvoiceRMAPdf(data)).then((res) => {
      const url = window.URL.createObjectURL(new Blob([res.payload]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `${getValues("invoice_no")}_${name.replace(/\s+/g, "-")}_${new Date().toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' }).replace(/\//g, '-')}.pdf`
      ); //or any other extension
      document.body.appendChild(link);
      link.click();
    });
  };

  const processXeroPDFDownload = (name) => {
    const orderId = order_id;
    const data = {
      id: id,
      params: {
        name: name,
        seller: authData.defaultSeller?.value,
      },
    };
    dispatch(downloadSalesOrderXeroInvoicePdf(data)).then((res) => {
      const url = window.URL.createObjectURL(new Blob([res.payload]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `${getValues("invoice_no")}_${name.replace(/\s+/g, "-")}_${new Date().toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' }).replace(/\//g, '-')}.pdf`
      ); //or any other extension
      document.body.appendChild(link);
      link.click();
    });
  };

  const paymentTypePromiseOption = (inputValue) =>
    new Promise((resolve) => {
      const data = {
        value: inputValue,
      };
      setTimeout(() => {
        resolve(
          mapSearchPaymentMethodAutoSuggestion(
            getPaymentAutoSuggestionApi(data)
          )
        );
      });
    });

  const downloadInvoice = (name, isCommercial) => {
    processPDFDownload(name, isCommercial);
  };

  const downloadRMA = (name, id) => {
    processRMAPDFDownload(name, id);
  };

  const downloadXeroInvoice = () => {
    processXeroPDFDownload("Xero Invoice");
  };

  // const onChangeDialog = (isTrigger) => {
  //   trigger("ordered_products");
  //   trigger("total_net_weight");
  // };

  const onChangeDialog = (isTrigger, isDiscountOnly = false) => {
    trigger("ordered_products");
    trigger("total_net_weight");

    if (isTrigger) {
      setIsDiscountValueChange((prev) => !prev);
      if (!isDiscountOnly) {
        setIsProductValueChange((prev) => !prev);
      }
    }
  };

  return (
    <>
      <Row className="mt-3">
        <Col
          md={12}
          className={
            salesOrderInvoiceState.orderInvoices.length > 5 ? "slick-arrow" : ""
          }
        >
          <Slider {...settings}>
            {salesOrderInvoiceState.orderInvoices.map((item, i) => (
              <div className="p-1 " key={i}>
                <Card className={id == item.id ? "active-invoice" : ""}>
                  <CardBody>
                    <Link
                      to={`${process.env.PUBLIC_URL}/order/sale/${order_id}/billing/invoice/${item.id}`}
                    >
                      <p className="font-weight-bolder f-14">
                        Invoice ID : {item.invoice_no}
                      </p>
                    </Link>
                    <p>Date : {formatDateTimeForDisplayUS(item.created_at)}</p>
                  </CardBody>
                </Card>
              </div>
            ))}
          </Slider>
        </Col>
      </Row>

      {id && (
        <Row>
          <Col md={12}>
            <Card>
              <CardBody style={{ padding: "24px" }}>
                {isDeleted && (
                  <Alert color="danger">
                    This invoice was deleted by {getValues("deleted_by")} on {getValues("deleted_at")}. It is read only.
                  </Alert>
                )}
                <div>
                  {weaverQbStatus ? (weaverQbStatus.status === 1 ? " Weaver QB invoice on queue" : weaverQbStatus?.error) : ""}
                  {djQbStatus ? (djQbStatus.status === 1 ? " D&J QB invoice on queue" : djQbStatus?.error) : ""}
                </div>
                {!isDeleted && (!getValues("is_online") ||
                  !getValues("is_product_edit_disable")) && (
                  <Link
                    className="btn btn-primary pull-right ml-2"
                    to={`${process.env.PUBLIC_URL}/order/sale/${order_id}/billing/invoice`}
                  >
                    Generate New Invoice
                  </Link>
                )}

                {getValues("return_request_items")?.length > 0 && (
                  <Dropdown isOpen={dropdownRMAOpen} toggle={toggleRMADropdown}>
                    <DropdownToggle
                      color="warning"
                      className="btn btn-sm btn-warning pull-right ml-2"
                      style={{
                        height: 38,
                        marginRight: 8,
                        fontSize: 14,
                        fontWeight: "bold",
                        letterSpacing: "1.1px",
                        font: "apple-System,Arial,Helvetica,PingFang SC,Hiragino Sans GB,Microsoft YaHei,STXihei,sans-serif",
                      }}
                    >
                      Download RMA{" "}
                      <i className="fa fa-caret-down" aria-hidden="true"></i>
                    </DropdownToggle>
                    <DropdownMenu>
                      {getValues("return_request_items").map((item) => (
                        <DropdownItem
                          key={item.id}
                          onClick={() => {
                            downloadRMA(`RMA-${item.id}`, item.id);
                          }}
                        >
                          {`RMA-${item.id}`}
                        </DropdownItem>
                      ))}
                    </DropdownMenu>
                  </Dropdown>
                )}

                {!isDeleted && getValues("xero_id") && (
                  <Link
                    // className="btn btn-primary pull-right ml-2"
                    className={`btn btn-info pull-right ml-2 ${
                      getValues("xero_id") ? "" : "disabled"
                    }`}
                    to={`${process.env.PUBLIC_URL}/order/sale/${order_id}/return/${id}`}
                  >
                    Return Invoice
                  </Link>
                )}

                <Dropdown
                  isOpen={dropdownStatusOpen}
                  toggle={toggleStatusDropdown}
                >
                  <DropdownToggle
                    color="warning"
                    className="btn btn-sm btn-warning pull-right ml-2"
                    style={{
                      height: 38,
                      marginRight: 8,
                      fontSize: 14,
                      fontWeight: "bold",
                      letterSpacing: "1.1px",
                      font: "apple-System,Arial,Helvetica,PingFang SC,Hiragino Sans GB,Microsoft YaHei,STXihei,sans-serif;",
                    }}
                  >
                    Download{" "}
                    <i className="fa fa-caret-down" aria-hidden="true"></i>
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem
                      onClick={() => {
                        downloadInvoice("Invoice", 0);
                      }}
                    >
                      Local Invoice
                    </DropdownItem>
                    <DropdownItem
                      onClick={() => {
                        downloadInvoice("Commercial Invoice", 1);
                      }}
                    >
                      Commercial Invoice
                    </DropdownItem>
                    {/* {getValues("xero_id") && (
                      <DropdownItem onClick={downloadXeroInvoice}>
                        Xero Invoice
                      </DropdownItem>
                    )} */}
                  </DropdownMenu>
                </Dropdown>

                {!isDeleted && (
                  ![1, 2].includes(weaverQbStatus?.status) &&
                  ![1, 2].includes(djQbStatus?.status)
                ) && (
                  <div className="pull-right ml-2">
                    <ButtonLoader
                      disabled={qbButtonDisable}
                      color="info"
                      value="1"
                      type="button"
                      onClick={() => {
                        sendToQuickBooks();
                      }}
                      btntext="Send to QuickBooks"
                    ></ButtonLoader>
                  </div>
                )}

                {!isDeleted && userState.user &&
                  userState.user.permission.indexOf("Invoices") !== -1 && (
                    <span
                      className="pull-right ml-2"
                      title={canDelete ? "" : deleteBlockReason}
                    >
                      <Button
                        color="danger"
                        type="button"
                        disabled={!canDelete}
                        onClick={onDeleteInvoice}
                      >
                        Delete
                      </Button>
                    </span>
                  )}

                {(!isDeleted && ( ![1,2].includes(weaverQbStatus?.status) && ![1,2].includes(djQbStatus?.status) ||
                  (getValues("is_online") &&
                    getValues("is_product_edit_disable"))) && (
                  <a
                    className="btn btn-success pull-right"
                    onClick={() => {
                      setIsEditable(!isEditable);
                    }}
                  >
                    {isEditable ? "View" : "Edit"}
                  </a>
                )) ||
                  ""}

              </CardBody>
            </Card>
          </Col>
        </Row>

      )}

      <Row className="mt-3">
        {id && (
          <div style={{ position: "fixed", top: "50%", zIndex: 10, right: 0 }}>
            <LogActivity log="Sales Order Invoice" id={id}></LogActivity>
          </div>
        )}
        <Col md={9}>
          <Form noValidate="" onSubmit={handleSubmit(onSubmit)}>
            {isEditable && !getValues("is_product_edit_disable") ? (
              <>
                {getValues("ordered_products").length > 0 ? (
                  <>
                    <Row>
                      <Col md={12}>
                        <Card>
                          <CardBody>
                            <Row>
                              <Col md={4}>
                                <FormGroup>
                                  <Label className="col-form-label">
                                    Terms
                                  </Label>
                                  <Select
                                    placeholder="Select Terms"
                                    type="select"
                                    name="term"
                                    getOptionLabel={(option) => option.name}
                                    getOptionValue={(option) => option.id}
                                    styles={{
                                      menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 100,
                                      }),
                                    }}
                                    value={getValues("terms")}
                                    isClearable
                                    options={
                                      salesOrderInvoiceState.formSettings.terms
                                    }
                                    onChange={(e) => {
                                      setValue("terms", e);
                                      const dueDate = moment()
                                        .add(e.no_of_days, "days")
                                        .format("YYYY-MM-DD");
                                      setValue("due_date", dueDate);
                                      trigger("terms");
                                      trigger("due_date");
                                    }}
                                    className={` ${
                                      errors.trackingName ? "is-invalid" : ""
                                    }`}
                                  />
                                  <div style={{ color: "red" }}>
                                    {errors.terms?.message}
                                  </div>
                                </FormGroup>
                              </Col>
                              <Col md={4}>
                                <FormGroup>
                                  <Label className="col-form-label">
                                    Due Date
                                  </Label>
                                  <DatePicker
                                    name="dispatchDate"
                                    className="form-control"
                                    selected={
                                      getValues("due_date")
                                        ? new Date(getValues("due_date"))
                                        : null
                                    }
                                    onChange={(date) => {
                                      setValue("due_date", date);
                                      trigger("due_date");
                                    }}
                                    minDate={moment().toDate()}
                                    style={{ minHeight: "auto" }}
                                    dateFormat="MM/dd/yyyy"
                                  />
                                  <div style={{ color: "red" }}>
                                    {errors.due_date?.message}
                                  </div>
                                </FormGroup>
                              </Col>
                              <Col md={4}>
                                <FormGroup>
                                  <Label className="col-form-label">
                                    Payment Method
                                  </Label>
                                  <AsyncSelect
                                    className={` ${
                                      errors.customer ? "is-invalid" : ""
                                    }`}
                                    isClearable
                                    cacheOptions
                                    defaultOptions
                                    defaultValue={getValues("payment_method")}
                                    loadOptions={paymentTypePromiseOption}
                                    onChange={(e) => {
                                      setValue("payment_method", e);
                                      trigger("payment_method");

                                      // if (e && e.value === 1) {
                                      //   setShowBankDropdown(true);
                                      // } else {
                                      //   setShowBankDropdown(false);
                                      //   setValue("bank", null);
                                      // }
                                    }}
                                  />
                                  <div style={{ color: "red" }}>
                                    {errors.bank?.message}
                                  </div>
                                </FormGroup>
                              </Col>

                              <Col md={4}>
                                <FormGroup>
                                  <Label className="col-form-label">
                                    PO Created
                                  </Label>
                                  <DatePicker
                                    name="po_created"
                                    className="form-control"
                                    selected={
                                      getValues("po_created")
                                        ? new Date(getValues("po_created"))
                                        : null
                                    }
                                    onChange={(date) => {
                                      setValue("po_created", date);
                                      trigger("po_created");
                                    }}
                                    style={{ minHeight: "auto" }}
                                    dateFormat="MM/dd/yyyy"
                                    isClearable
                                  />
                                </FormGroup>
                              </Col>

                              {/* {showBankDropdown && (
                                <Col md={3}>
                                  <FormGroup>
                                    <Label className="col-form-label">
                                      Bank
                                    </Label>
                                    <Select
                                      placeholder="Select Bank"
                                      type="select"
                                      name="bank"
                                      getOptionLabel={(option) => option.name}
                                      getOptionValue={(option) => option.id}
                                      styles={{
                                        menuPortal: (base) => ({
                                          ...base,
                                          zIndex: 100,
                                        }),
                                      }}
                                      value={getValues("bank")}
                                      isClearable
                                      options={
                                        salesOrderInvoiceState.formSettings
                                          .banks
                                      }
                                      onChange={(e) => {
                                        setValue("bank", e);
                                        trigger("bank");
                                      }}
                                      className={` ${
                                        errors.bank ? "is-invalid" : ""
                                      }`}
                                    />
                                    <div style={{ color: "red" }}>
                                      {errors.bank?.message}
                                    </div>
                                  </FormGroup>
                                </Col>
                              )} */}

                              {/* <Col md={3}>
                                <FormGroup>
                                  <Label className="col-form-label">
                                    Trade Option
                                  </Label>
                                  <Select
                                    placeholder="Select Trade Option"
                                    type="select"
                                    name="trade_option"
                                    getOptionLabel={(option) => option.name}
                                    getOptionValue={(option) => option.id}
                                    styles={{
                                      menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 100,
                                      }),
                                    }}
                                    value={getValues("trade_option")}
                                    isClearable
                                    options={
                                      salesOrderInvoiceState.formSettings
                                        .term_trade_options
                                    }
                                    onChange={(e) => {
                                      setValue("trade_option", e);
                                      trigger("trade_option");
                                    }}
                                    className={` ${
                                      errors.trade_option ? "is-invalid" : ""
                                    }`}
                                  />
                                  <div style={{ color: "red" }}>
                                    {errors.trade_option?.message}
                                  </div>
                                </FormGroup>
                              </Col> */}
                            </Row>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={12}>
                        <Card>
                          <CardBody>
                            <p>Products</p>
                            <div className="selection-grid">
                              <SaleOrderProductInvoiceJqx
                                setValue={setValue}
                                getValues={getValues}
                                trigger={trigger}
                                orderedProducts={getValues("ordered_products")}
                                isProductValueChange={isProductValueChange}
                                isDiscountValueChange={isDiscountValueChange}
                                // setIsDiscountValueChange={setIsDiscountValueChange}
                                onChangeDialog={onChangeDialog}
                                currency={salesOrderState.orderData.symbol}
                              ></SaleOrderProductInvoiceJqx>
                            </div>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={4}>
                        <PickUpDetail
                          setValue={setValue}
                          getValues={getValues}
                          trigger={trigger}
                          errors={errors}
                          id={id}
                          register={register}
                        ></PickUpDetail>
                      </Col>
                      <Col md={8}>
                        {getValues("ordered_products").length > 0 && (
                          <div>
                            <SaleOrderPayment
                              setValue={setValue}
                              getValues={getValues}
                              trigger={trigger}
                              currency={salesOrderState.orderData.symbol}
                            ></SaleOrderPayment>
                            <div
                              style={{
                                color: "red",
                                float: "right",
                              }}
                            >
                              {errors.shipping?.message}
                            </div>
                          </div>
                        )}
                      </Col>
                    </Row>
                  </>
                ) : (
                  <div className="search-not-found text-center">
                    <div>
                      <img
                        className="img-fluid second-search"
                        src={require("../../../../../assets/images/search-not-found.png")}
                        alt=""
                      />
                      <p> All Ordered items are invoiced</p>
                    </div>
                  </div>
                )}
              </>
            ) : (
              <SalesOrderInvoiceView
                isEditable={isEditable}
                invoiceData={getValues}
                setValue={setValue}
                getValues={getValues}
                trigger={trigger}
                errors={errors}
                id={id}
                register={register}
                currency={salesOrderState?.orderData?.symbol}
              />
            )}

            {getValues("ordered_products").filter(function (v, i) {
              return v.is_selected;
            }).length > 0 &&
              isEditable && (
                <Row>
                  <Col md={12}>
                    <Card>
                      <CardBody>
                        <div className="pull-right">
                          <ButtonLoader
                            disabled={buttonDisable}
                            color="primary"
                            value="1"
                            type="submit"
                            btntext="Save"
                          ></ButtonLoader>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              )}
          </Form>
        </Col>
        <Col md={3}>
          <BillingOrderDetail
            orderProducts={getValues("ordered_products").filter(function (
              v,
              i
            ) {
              return v.is_selected;
            })}
          ></BillingOrderDetail>
        </Col>
      </Row>
      <Row className="mt-3"></Row>
      <OrderDiscount
        orderSetValue={setValue}
        orderTrigger={trigger}
        orderGetValues={getValues}
      ></OrderDiscount>
      <OrderShipment
        draftOrderState={draftOrderState}
        orderSetValue={setValue}
        orderTrigger={trigger}
        orderGetValues={getValues}
      ></OrderShipment>
      <OrderTax
        orderSetValue={setValue}
        orderTrigger={trigger}
        orderGetValues={getValues}
      ></OrderTax>
      <SalesOrderDuty
        orderSetValue={setValue}
        orderTrigger={trigger}
        orderGetValues={getValues}
      ></SalesOrderDuty>
      {/* <OrderInvoiceItemDiscount
        rowdata={selectedRowData}
        orderGetValues={getValues}
        orderSetValue={setValue}
        orderTrigger={trigger}
        onChangeDialog={onChangeDialog}
      ></OrderInvoiceItemDiscount> */}

      <Modal isOpen={qbCompanyModal} toggle={() => setQbCompanyModal(false)} centered>
        <ModalHeader toggle={() => setQbCompanyModal(false)}>
          <i className="fa fa-book mr-2" style={{ color: "#2CA01C" }}></i>
          Send to QuickBooks
        </ModalHeader>
        <ModalBody style={{ padding: "24px" }}>
          <p className="text-muted mb-3" style={{ fontSize: 13 }}>
            Select the QuickBooks company to sync this invoice with:
          </p>
          <Row>
            <Col sm="6">
              <div
                onClick={() => setSelectedQbCompany("weaver")}
                style={{
                  border: `2px solid ${selectedQbCompany === "weaver" ? "#007bff" : "#dee2e6"}`,
                  borderRadius: 8,
                  padding: "20px 16px",
                  cursor: "pointer",
                  backgroundColor: selectedQbCompany === "weaver" ? "#f0f7ff" : "#fff",
                  transition: "all 0.2s ease",
                  textAlign: "center",
                  position: "relative",
                }}
              >
                {selectedQbCompany === "weaver" && (
                  <span
                    style={{
                      position: "absolute",
                      top: 8,
                      right: 10,
                      color: "#007bff",
                      fontSize: 16,
                    }}
                  >
                    <i className="fa fa-check-circle"></i>
                  </span>
                )}
                <div
                  style={{
                    width: 50,
                    height: 50,
                    borderRadius: "50%",
                    backgroundColor: selectedQbCompany === "weaver" ? "#007bff" : "#6c757d",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "0 auto 12px",
                    transition: "background-color 0.2s ease",
                  }}
                >
                  <i className="fa fa-building" style={{ color: "#fff", fontSize: 20 }}></i>
                </div>
                <div style={{ fontWeight: 600, fontSize: 14, color: selectedQbCompany === "weaver" ? "#007bff" : "#343a40" }}>
                  Weaver
                </div>
                <div style={{ fontSize: 12, color: "#6c757d", marginTop: 4 }}>
                  QuickBooks
                </div>
              </div>
            </Col>
            <Col sm="6">
              <div
                onClick={() => setSelectedQbCompany("dj")}
                style={{
                  border: `2px solid ${selectedQbCompany === "dj" ? "#007bff" : "#dee2e6"}`,
                  borderRadius: 8,
                  padding: "20px 16px",
                  cursor: "pointer",
                  backgroundColor: selectedQbCompany === "dj" ? "#f0f7ff" : "#fff",
                  transition: "all 0.2s ease",
                  textAlign: "center",
                  position: "relative",
                }}
              >
                {selectedQbCompany === "dj" && (
                  <span
                    style={{
                      position: "absolute",
                      top: 8,
                      right: 10,
                      color: "#007bff",
                      fontSize: 16,
                    }}
                  >
                    <i className="fa fa-check-circle"></i>
                  </span>
                )}
                <div
                  style={{
                    width: 50,
                    height: 50,
                    borderRadius: "50%",
                    backgroundColor: selectedQbCompany === "dj" ? "#007bff" : "#6c757d",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "0 auto 12px",
                    transition: "background-color 0.2s ease",
                  }}
                >
                  <i className="fa fa-building" style={{ color: "#fff", fontSize: 20 }}></i>
                </div>
                <div style={{ fontWeight: 600, fontSize: 14, color: selectedQbCompany === "dj" ? "#007bff" : "#343a40" }}>
                  D&amp;J
                </div>
                <div style={{ fontSize: 12, color: "#6c757d", marginTop: 4 }}>
                  QuickBooks
                </div>
              </div>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={confirmQbSync}>
            <i className="fa fa-paper-plane mr-1"></i> Proceed
          </Button>
          <Button color="light" onClick={() => setQbCompanyModal(false)}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};
export default withReducer([{ salesOrderInvoice: salesOrderInvoiceReducer }])(
  BillIngInvoice
);


